/**
 * Grid container for project cards
 * Story 226: Projects Dashboard
 */

import type { ProjectListItem } from '../../hooks/useProjects';
import { ProjectCard } from './ProjectCard';
import './ProjectsGrid.css';

interface ProjectsGridProps {
  projects: ProjectListItem[];
  onSelectProject: (projectSlug: string) => void;
  onExport?: (slug: string) => void;
}

export function ProjectsGrid({ projects, onSelectProject, onExport }: ProjectsGridProps) {
  return (
    <div className="projects-grid">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onClick={() => onSelectProject(project.slug)}
          onExport={onExport}
        />
      ))}
    </div>
  );
}
